import React from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';

interface AdminDashboardProps {
  user: CognitoUser | null;
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({ user }) => {
  return (
    <div>
      <h1>Admin Dashboard</h1>
      <p>Coming soon...</p>
    </div>
  );
};

export default AdminDashboard;